/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_External_Booking_Edit_Go_To_ResourceInputs */

const en_admin_external_booking_edit_go_to_resource = /** @type {(inputs: Admin_External_Booking_Edit_Go_To_ResourceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Go to resource »`)
};

const de_admin_external_booking_edit_go_to_resource = /** @type {(inputs: Admin_External_Booking_Edit_Go_To_ResourceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zur Ressource »`)
};

const es_admin_external_booking_edit_go_to_resource = /** @type {(inputs: Admin_External_Booking_Edit_Go_To_ResourceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ir al recurso »`)
};

const fr_admin_external_booking_edit_go_to_resource = /** @type {(inputs: Admin_External_Booking_Edit_Go_To_ResourceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aller à la ressource »`)
};

const nl_admin_external_booking_edit_go_to_resource = /** @type {(inputs: Admin_External_Booking_Edit_Go_To_ResourceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Naar voorziening »`)
};

/** @type {(inputs: Admin_External_Booking_Edit_Go_To_ResourceInputs) => LocalizedString} */
const it_admin_external_booking_edit_go_to_resource = en_admin_external_booking_edit_go_to_resource;

/** @type {(inputs: Admin_External_Booking_Edit_Go_To_ResourceInputs) => LocalizedString} */
const pt_br2_admin_external_booking_edit_go_to_resource = en_admin_external_booking_edit_go_to_resource;

/** @type {(inputs: Admin_External_Booking_Edit_Go_To_ResourceInputs) => LocalizedString} */
const pl_admin_external_booking_edit_go_to_resource = en_admin_external_booking_edit_go_to_resource;

/** @type {(inputs: Admin_External_Booking_Edit_Go_To_ResourceInputs) => LocalizedString} */
const hu_admin_external_booking_edit_go_to_resource = en_admin_external_booking_edit_go_to_resource;

/** @type {(inputs: Admin_External_Booking_Edit_Go_To_ResourceInputs) => LocalizedString} */
const ro_admin_external_booking_edit_go_to_resource = en_admin_external_booking_edit_go_to_resource;

/**
* | output |
* | --- |
* | "Go to resource »" |
*
* @param {Admin_External_Booking_Edit_Go_To_ResourceInputs} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }} options
* @returns {LocalizedString}
*/
const admin_external_booking_edit_go_to_resource = /** @type {((inputs?: Admin_External_Booking_Edit_Go_To_ResourceInputs, options?: { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_External_Booking_Edit_Go_To_ResourceInputs, { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_external_booking_edit_go_to_resource(inputs)
	if (locale === "de") return de_admin_external_booking_edit_go_to_resource(inputs)
	if (locale === "es") return es_admin_external_booking_edit_go_to_resource(inputs)
	if (locale === "fr") return fr_admin_external_booking_edit_go_to_resource(inputs)
	if (locale === "nl") return nl_admin_external_booking_edit_go_to_resource(inputs)
	if (locale === "it") return it_admin_external_booking_edit_go_to_resource(inputs)
	if (locale === "pt-BR") return pt_br2_admin_external_booking_edit_go_to_resource(inputs)
	if (locale === "pl") return pl_admin_external_booking_edit_go_to_resource(inputs)
	if (locale === "hu") return hu_admin_external_booking_edit_go_to_resource(inputs)
	return ro_admin_external_booking_edit_go_to_resource(inputs)
});
export { admin_external_booking_edit_go_to_resource as "admin.external_booking_edit.go_to_resource" }